declare namespace $ {

	export class $mol_icon_tag extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=tag.view.tree.d.ts.map